import { parseMediaUrl } from 'helpers/File';
import isEmpty from 'lodash/isEmpty';
import { isVideo } from 'modules/file/helpers';

import Store from './AdvertisementEditorStore';
import { NO_SUBSCRIPTION } from './constants';

class AdvertisementDataService {
  getData(advertisement) {
    const { id } = Store;
    const { product = {}, offer = {} } = advertisement;

    const mediasObj = this.mediasObj(advertisement);

    const advertisementData = {
      mediaId: mediasObj.mediaId,
      imageId: mediasObj.imageId,
      mediaVideoUrl: mediasObj.mediaVideoUrl,
      mediaVideoProvider: mediasObj.mediaVideoProvider,
      affiliateHotlink: !product.owner
        ? offer[NO_SUBSCRIPTION] && offer[NO_SUBSCRIPTION].url
        : null,
      affiliationKey: !product.owner ? product.affiliationKey : null,
      marketplaceProductId: product.id,
      owner: product.owner,
      subscription: product.subscription,
      offers: product.owner ? this.offersArray(offer) : null
    };

    if (id) {
      advertisementData.id = id;
    }

    return advertisementData;
  }

  mediasObj(advertisement) {
    const { mediaVideoUrl } = Store;
    const { media } = advertisement;

    const mediasObj = {
      mediaId: null,
      imageId: null,
      mediaVideoUrl: null,
      mediaVideoProvider: null
    };

    if (!isEmpty(media)) {
      if (isVideo(media)) {
        mediasObj.mediaId = this.formatMediaId(media);
      } else {
        mediasObj.imageId = this.formatMediaId(media);
      }
    }

    if (!isEmpty(mediaVideoUrl)) {
      mediasObj.mediaVideoUrl = mediaVideoUrl;
      mediasObj.mediaVideoProvider = parseMediaUrl(mediaVideoUrl).type;
    }

    return mediasObj;
  }

  offersArray(offer) {
    return Object.keys(offer).map((key) => {
      const offerMapped = {};

      if (offer[key].id) {
        offerMapped.id = offer[key].id;
      }

      offerMapped.offerKey = offer[key].key;

      return offerMapped;
    });
  }

  formatMediaId = (media) => media.id || media.fileId;
}

export default new AdvertisementDataService();
